export default __webpack_public_path__ + "ff4c9c5.png";